import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Terminal, Webhook, Zap, Cpu, Settings2, Plug, Cloud, Database, Activity } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Python Application Development",
        icon: <Terminal size="64" strokeWidth='1' />,
        content: "Reliable, well-tested Python applications built for correctness and long-term maintainability."
    },
    {
        id: 2,
        title: "REST API Development",
        icon: <Webhook size="64" strokeWidth='1' />,
        content: "Secure, well-documented REST APIs that connect your frontend, mobile apps, and third-party systems."
    },
    {
        id: 3,
        title: "FastAPI & Django Expertise",
        icon: <Zap size="64" strokeWidth='1' />,
        content: "Deep experience with FastAPI and Django, choosing the right framework for your performance and productivity needs."
    },
    {
        id: 4,
        title: "Backend Architecture & Business Automation",
        icon: <Cpu size="64" strokeWidth='1' />,
        content: "Scalable backend architecture combined with business process automation that removes manual, repetitive work."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "Python Development",
        icon: <Terminal size="42" strokeWidth='1' />,
        content: "Robust Python applications built with modern best practices."
    },
    {
        id: 2,
        title: "REST API Design",
        icon: <Webhook size="42" strokeWidth='1' />,
        content: "Clean, well-structured REST APIs designed for reliability and scale."
    },
    {
        id: 3,
        title: "FastAPI & Django",
        icon: <Zap size="42" strokeWidth='1' />,
        content: "Production-ready backends built with FastAPI and Django."
    },
    {
        id: 4,
        title: "Backend Architecture",
        icon: <Cpu size="42" strokeWidth='1' />,
        content: "Architecture decisions that keep your backend scalable as you grow."
    },
    {
        id: 5,
        title: "Business Process Automation",
        icon: <Settings2 size="42" strokeWidth='1' />,
        content: "Automate repetitive business workflows to save time and reduce errors."
    },
    {
        id: 6,
        title: "Third-Party API Integrations",
        icon: <Plug size="42" strokeWidth='1' />,
        content: "Integrate the external services and platforms your business already relies on."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Cloud Deployment",
        icon: <Cloud size="54" strokeWidth='1' />,
        content: "Deploy and scale your Python backend on modern cloud infrastructure."
    },
    {
        id: 2,
        title: "Database Integration",
        icon: <Database size="54" strokeWidth='1' />,
        content: "Well-modeled database integration that keeps your data consistent and fast."
    },
    {
        id: 3,
        title: "Monitoring & Support",
        icon: <Activity size="54" strokeWidth='1' />,
        content: "Ongoing monitoring and support to keep your backend healthy in production."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const PythonBackendDevelopment = () => {
    return (
        <>
            <PageHelmet
                pageTitle="Python & Backend Development"
                description="Harsoft Solutions offers Python development services — REST APIs, FastAPI and Django applications, backend architecture, business automation, and API integrations."
                keywords="Python Development, REST API Development, FastAPI, Django, Backend Architecture, Business Automation"
                path="/python-backend-development"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="Python & Backend Development" subtitle="Python & Backend Development" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Reliable Backends, Built with Python" content="Our Python development services cover REST APIs, FastAPI and Django applications, backend architecture, and business automation — engineered for reliability at scale." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/offerings/software_dev.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default PythonBackendDevelopment;
